const PREFIX = 'APP';

export const CLEAR_SERVER_ERRORS = `${PREFIX}/CLEAR_SERVER_ERRORS`;
export const REQUEST_FAILURE = `${PREFIX}/REQUEST_FAILURE`;
export const REQUEST_FINISHED = `${PREFIX}/REQUEST_FINISHED`;
export const REQUEST_STARTED = `${PREFIX}/REQUEST_STARTED`;

export const REQUEST_SUCCESS = `${PREFIX}/REQUEST_SUCCESS`;
export const CLEAR_SERVER_SUCCESS = `${PREFIX}/CLEAR_SERVER_SUCCESS`;


export const MODAL_OPEN = `${PREFIX}/MODAL_OPEN`;
export const MODAL_CLOSE = `${PREFIX}/MODAL_CLOSE`;



// WEBPACK FOOTER //
// ./src/state/app/app.actionTypes.js